import { inject, Injectable, LOCALE_ID } from "@angular/core";

export type FrontendLanguage = "fr" | "de" | "it";
@Injectable({
  providedIn: "root",
})
export class LanguageService {
  private readonly frontendLanguages: FrontendLanguage[] = ["fr", "de", "it"];
  readonly locale = inject(LOCALE_ID);

  getFrontendLanguages(): FrontendLanguage[] {
    return this.frontendLanguages;
  }

  getCurrentLanguage(): FrontendLanguage {
    return this.locale as FrontendLanguage;
  }
}
